import ENV from "../../env";
import getAuthHeaders from "../authHeaders";

const deleteShowroom = async (showroomId) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(
    `${ENV.firebaseApiUrl}/showroom/delete/${showroomId}`,
    {
      method: "DELETE",
      headers,
    }
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Delete Showroom failed: " + resData.message);
  }

  return resData.showroomId;
};

export default deleteShowroom;
